import { useMutation, useQueryClient } from '@tanstack/react-query';
import useModal from '../../components/partials/Modal/useModal';
import useApiStore from '../../store/useApiStore';
import { CAMPAIGNS_KEY } from '../../utils/constants';
import Api from '../Api';
import { toastSuccess } from '../../components/partials/Toast/Toast';

export default function useDeleteCampaign() {
  const { onError } = useApiStore();
  const queryClient = useQueryClient();
  const { hideModal } = useModal();

  return useMutation({
    mutationFn: async (payload: string) => {
      const api = new Api({ onError });

      const data = await api.delete({
        url: `api/v1/campaigns/${payload}`,
      });

      return data;
    },
    onSuccess: () => {
      toastSuccess('Successfully deleted campaign.');

      queryClient.invalidateQueries({ queryKey: [CAMPAIGNS_KEY] });

      hideModal();
    },
  });
}
